module.exports = __webpack_public_path__ + "static/media/icon-download-green.36c3422c.svg";